import React, { useEffect, useState, useRef } from 'react';
interface FinalCTAProps {
  openModal: () => void;
}
export function FinalCTA({
  openModal
}: FinalCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <div ref={sectionRef} className="relative w-full py-32 md:py-40 flex items-center justify-center overflow-hidden bg-white dark:bg-charcoal-900" data-id="element-88">
      <div className={`max-w-4xl mx-auto text-center px-6 md:px-12 relative z-10 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} data-id="element-89">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 text-charcoal-500 dark:text-white" data-id="element-90">
          Ready to eat out without the stress?
        </h2>
        <p className="text-xl text-charcoal-400 dark:text-charcoal-300 mb-4 leading-relaxed" data-id="element-91">
          Download Caltalk and never guess what or where to eat again.
        </p>
        <p className="text-lg text-charcoal-400 dark:text-charcoal-400 mb-12" data-id="element-92">
          Available on iOS. Android coming soon.
        </p>
        <button onClick={openModal} className="px-10 py-5 text-lg font-semibold rounded-full bg-gradient-coral text-white hover:bg-gradient-coral-hover transition-all duration-300 shadow-2xl hover:shadow-coral-500/30 hover:scale-105 mb-8" data-id="element-93">
          Download Now
        </button>
        <div className="flex justify-center gap-4 mt-8" data-id="element-94">
          <a href="#" className="inline-block hover:opacity-80 transition-opacity" data-id="element-95">
            <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83" alt="Download on the App Store" className="h-14" data-id="element-96" />
          </a>
        </div>
      </div>
    </div>;
}